import { Navigate, Route, Routes } from "react-router-dom"
import Carousels from "./views/Carousels"
import ClassifyStructureTypeCarousel from "./views/ClassifyStructureTypeCarousel"
const MainRoute = ({

}) => {
    return (<>
        <Routes>
            <Route path={''}>
                <Route index element={<Navigate to={'/app/carousels/primary'} />} />
                <Route path={'home'}
                    element={<Carousels
                        defaultSize={5}
                    />} />
                <Route path={':name'}
                    element={<ClassifyStructureTypeCarousel
                        defaultSize={5}
                    />} />
            </Route>
        </Routes>
    </>)
}
export default MainRoute